import type { InjectionKey } from 'vue';
import type { NormalizedPreconAuthenticationGlobalOptions } from './options';

/**
 * The injection to get the options into the components.
 */
export const preconAuthenticationOptionsInjectionKey = Symbol(
    'precon-authentication library options'
) as InjectionKey<Readonly<NormalizedPreconAuthenticationGlobalOptions>>;
